import React from "react";

const Supplierinvoices = () => {
	return <div>CRM, Not implemened yet</div>;
};
export default Supplierinvoices;
